import {OvertimeSearchRequest} from './OvertimeSearchRequest';


export class OvertimeReportRequest {
    
    overtimeSearch : OvertimeSearchRequest  ;
    overtimeTabType : string ;
    
    constructor(overtimeSearch: any, overtimeTabType: any) {
        this.overtimeSearch = overtimeSearch;
        this.overtimeTabType = overtimeTabType;
    }
}

export class OvertimeReportDto {
    branchCode: string;
    departmentId: number;
    fullName: string;
    overtimeStartDate: string;
    overtimeEndDate: string;
    overtimeTypeId: number ;
    pageNumber: number ;
    projectCode: string;
    size: number;
    sortColumn: string;
    sortDirection: number;
    tenantCode: string;
}

export class OvertimeReportResponse {
    sheet1: OvertimeReportDto[];
    sheetNames: string[];
    workBookName: string;
}